import { css } from "styled-components";
import { getColor } from "@/pipes/theme.pipe";

const variantOptions = {
    standard: css`
        input, .stdropdown-menu, &.ant-select, .ant-select-item-option {
            background-color: ${getColor('natural')};
        }

        :is(.ant-select-item-option, .stdropdown-item):hover {
            background-color: ${getColor('natural', '600')} !important;
        }
    `,
    convex: css`
        input, .stdropdown-menu, &.ant-select {
            background-color: ${getColor('natural', '600')} !important;
            box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 7%);
        }

        .stdropdown-item:hover {
            background-color: ${getColor('natural')} !important;
        }
        
        .ant-select-item-option-active, .ant-select-item-option-selected {
            background: ${getColor('natural')} !important;
        }
    `,
    light: css`
        input, .stdropdown-menu, &.ant-select, .ant-select-item-option {
            background-color: transparent !important;
        }

        .ant-select-item-option-active, .ant-select-item-option-selected {
            background: ${getColor('natural')} !important;
        }
    `
}

export const getVariantStyles = ({variant}) => variantOptions[variant] || variantOptions['standard']